<template>
    <rkm-form ref="Form">
        <rkm-row>
            <rkm-col>
                <rkm-form-textarea
                    :validations="validations.observacoes"
                    rows="6"
                    v-model="exame.observacoes"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
export default {
    computed: {
        validations() {

            return {
                observacoes: { max: 1000 },
            }
        },
    },
    methods: {
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.originalExame.observacoes = this.exame.observacoes

                    this.$emit('save')
                })
        },
    },
    props: {
        originalExame: { type: Object, required: true },
        exame: { type: Object, required: true },
    },
}
</script>